// i18n area 'storage' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.sv-SE.meta.json.
import type { enUS } from './storage'

export const svSE: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Skapa storage',
      path: 'Sökväg',
      pathHint: 'Absolut sökväg under en tillåten rot (standard /var/lib/tvirt/pools/)',
      shared: 'Delad storage',
      sharedChip: 'delad',
      sharedVerifiedChip: 'delad · verifierad',
      sharedVerifiedTooltip: 'Delningen verifierad: de korsade sonderna bekräftar att varje medlem ser data som de andra skrivit.',
      sharedDisputedChip: 'delad · INTE verifierad',
      sharedDisputedTooltip: 'Delningen INTE verifierad',
      sharedDisputedPair: '{observer} ser inte data skrivna av {writer}',
      sharedHint: 'Nätverksshare monterad lokalt på samma path på varje medlem — förutsättning för live migration (deklarativt).',
      sharedDanger: 'FARA — TVirt TROR på den här flaggan: slår du på den antar varje medlem att den ser SAMMA byte på den här pathen. På en mapp som INTE är en verkligt delad share (NFS/CIFS/klusterfilsystem) blir resultatet korruption och dataförlust vid första migreringen eller första HA-omstarten på en annan nod. Slå på den bara om pathen är en share som är identiskt monterad på varje nod.',
      type: 'Typ',
      capacity: 'Kapacitet',
      provisioned: 'Allokerat',
      provisionedOvercommit: 'Potentiellt åtagande bortom kapaciteten: thin-volymerna kan växa upp till {n} GiB.',
      phase: { ready: 'Redo', degraded: 'Degraderad', error: 'Fel' },
      tabConfig: 'Konfiguration',
      tabCapacity: 'Kapacitet och tillstånd',
      cardIdentity: 'Identitet',
      cardPlacement: 'Placering',
      cardConnection: 'Anslutning',
      usedReal: 'Verklig beläggning',
      capacityUnknown: 'Noden har ännu inte rapporterat kapaciteten för den här poolen — här hittas inga siffror på',
      overcommitHint: 'Åtagande bortom kapaciteten: legitimt på thin-pooler, håll ögonen på den verkliga beläggningen',
      supportedContent: 'Innehåll som stöds',
      content: {
        disks: 'Diskar',
        catalogFiles: 'Katalogfiler',
        backups: 'Backuper',
        appVolumes: 'App-volymer'
      },
      defaultDiskFormat: 'Standardformat för diskar',
      reserveGiB: 'Reserverat fritt utrymme (GiB)',
      available: 'Tillgängligt',
      diskCount: 'Diskar',
      filesystem: 'Filsystem',
      observedAt: 'Observerad den',
      lostAtRow: 'Förklarad förlorad den',
      sharedProbeRow: 'Delningsverifiering',
      sharedProbeNodes: 'Sonderade noder',
      reachableFrom: 'Deklarerad nåbarhet',
      reachableFromHint: 'Noderna som den här storagen ska vara nåbar från. En VM med diskar, ISO eller metadata här ovanpå varken startar eller migrerar till en nod utanför den här listan. Alla medlemmar är förvalda: snäva in som du vill. En nod som går med i klustret senare står utanför tills du lägger till den här.',
      reachableFromNone: 'inte deklarerad',
      reachableFromTags: 'Nåbarhet per tagg',
      reachableFromTagsHint: 'Väljare tag=värde (kommaseparerade poster, AND): varje medlem som bär dessa taggar förklaras nåbar — dynamiskt: tagga en nod så kommer den med.',
      reachableFromTagsInvalid: 'Ogiltigt format — använd tag=värde, kommaseparerat',
      reachableResolved: 'Upplösta noder: {nodes}',
      reachableDeclaredNotSeen: 'deklarerad men inte sedd av delningssonden på: {nodes}',
      reachableSeenNotDeclared: 'sedd men inte deklarerad (utanför perimetern) på: {nodes}',
      cephCluster: 'Hanterat Ceph-kluster',
      appGuardTitle: 'Storage som används av apparna',
      appEphemeralGuard: 'den här storagen är appernas efemära klusterpool — byt den först från App-sidan, radera den sedan.',
      appInUseGuard: 'här bor app-rooter/-volymer: {apps} — flytta eller radera dem först.',
      releaseRequiredTitle: "Radera '{name}' och frigör dess avbilder?",
      releaseRequiredBatchTitle: 'Radera de valda storagerna och frigör deras avbilder?',
      releaseRequiredBody: 'Att frigöra avbilderna raderar INGA byte: avregistreringen lämnar kvar namespace på disken, avbilderna är helt enkelt inte längre materialiserade och varje referens från scopen överlever som claim — registrera poolen igen så adopteras de på nytt.',
      releaseConfirm: 'Radera och frigör avbilderna'
    },
    lost: {
      chip: 'Förlorad',
      action: 'Förklara förlorad',
      confirmTitle: 'Förklara storagen förlorad',
      confirmBody: 'Ett operatörsintyg på egen deklarerad risk: varje task i kö eller under körning på den här storagen eller dess objekt kommer att MISSLYCKAS, raderingar blir endast registerposter (inget filsystemsarbete) och nytt fysiskt arbete avvisas. Bytena rörs aldrig — om volymen vaknar till liv igen, registrera den på nytt och kör en scan för att återadoptera allt.',
      confirmSubmit: 'Förklara förlorad',
      error: 'Intyget avvisades'
    },
    findings: {
      action: 'Hittade objekt',
      title: 'Hittade objekt',
      empty: 'Inget objekt hittat i storagens namespace',
      loadError: 'Kunde inte läsa in de hittade objekten',
      actionError: 'Beslutet avvisades',
      colKind: 'Typ',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Den här katalogen var redan initierad av en annan lagring: identitetssigillet har skrivits över med den här lagringens. Innehållet rördes INTE — gå igenom objekten som hittades nedan, importera dem du behöver och avfärda sedan det här meddelandet.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalogfil',
        vmMetadata: 'VM-metadata',
        namespace: 'Namespace',
        foreign: 'Främmande',
        volumeGroup: 'Volume group'
      },
      vgAdopt: {
        action: 'Adoptera volume group',
        title: 'Adoptera volume group',
        intro:
          'Den här enheten bär redan en volume group med ett TVirt-namn, men dess sigill nämner ingen storage som är registrerad här. Det kan vara vad en tidigare storage i DETTA kluster lämnade på LUN:en — eller vad ETT ANNAT TVirt-kluster lämnade på en LUN som bytt händer: härifrån ser de två fallen identiska ut, och därför bestämmer ingen åt dig.',
        irreversible: 'Titta på enheten, sigillet och namnet innan du fortsätter: adoptionen går inte att ångra.',
        device: 'Enhet',
        seal: 'Sigill',
        sealNone: 'inget (ingen tvirt.storageId-tagg)',
        renameTo: 'Den byter namn till',
        renameNone: 'Ingen namnändring: namnet är redan det som denna storage härleder',
        volumesNote:
          'De volymer den innehåller adopteras INTE av den här gesten: nästa skanning erbjuder dem en och en, som vanliga funna objekt.'
      },
      conflictChip: 'ID finns redan',
      dismissedChip: 'Ignorerat',
      adopt: 'Adoptera',
      adoptFileTitle: 'Importera till en katalog',
      adoptFileHint: 'Filer finns bara inuti kataloger: välj målkatalog för den hittade filen.',
      purge: 'Radera från disken',
      dismiss: 'Ignorera',
      purgeConfirmTitle: 'Radera från disken',
      purgeConfirmBody: 'De hittade bytena för {id} tas bort från storagen. Operationen går inte att ångra.',
      taskStarted: 'Startad — fortsätter som task i bakgrunden',
      scan: 'Skanna storagen',
      scanStarted: 'Skanningen startad…',
      scanDone: 'Skanningen klar — de hittade objekten är uppdaterade'
    },
    reinit: {
      action: 'Försök initieringen igen'
    },
    wizard: {
      addButton: 'Lägg till',
      title: 'Lägg till storage',
      back: 'Tillbaka',
      continue: 'Fortsätt',
      selectHint: 'Välj ett protokoll för att se hur TVirt använder det.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Exporterad sökväg',
      share: 'Share',
      username: 'Användarnamn',
      password: 'Lösenord',
      passwordHint: 'Endast skrivning: används för mounten, visas aldrig igen.',
      credential: 'Autentiseringsuppgift',
      credentialManual: 'Ange manuellt',
      credentialHint: 'En keystore-post av typen användarnamn och lösenord — alternativet till att skriva in dem här.',
      credentialEmpty: 'Ingen autentiseringsuppgift av typen användarnamn och lösenord i keystoren — skapa den i System → Autentiseringsuppgifter, eller skriv in kontot här nedanför.',
      options: 'Mount-alternativ',
      optionsHint: 'Kommaseparerade, skickas till mount -o precis som de är.',
      portal: 'Portal',
      portalHint: 'host[:port] — standardporten är 3260.',
      target: 'Target-IQN',
      targetHint: 'iSCSI-targetens namn, börjar med iqn.',
      lun: 'LUN',
      wholeLunRow: 'På diskarna: den här lagringen namnger bara targeten',
      wholeLunHint: 'Den här lagringen namnger bara targeten: dess LUN:er blir diskar en i taget (Skapa disk → ta över hel LUN), inget skrivs på targeten.',
      lunHint: 'LUN-nummer på targeten — 0 om du är osäker.',
      chapCredential: 'Autentiseringsuppgift (CHAP)',
      chapCredentialHint: 'En keystore-post av typen CHAP (iSCSI) som används vid inloggningen — hemligheten färdas aldrig med storagen.',
      chapNone: 'Ingen autentisering',
      chapEmpty: 'Ingen autentiseringsuppgift av typen CHAP (iSCSI) i keystoren — skapa den i System → Autentiseringsuppgifter. Utan den förblir inloggningen oautentiserad.',
      address: 'Adress',
      addressHint: 'Host eller IP för NVMe/TCP-targeten (traddr).',
      port: 'Port',
      portHint: 'Targetens TCP-port — 4420 om den lämnas tom.',
      targetNqn: 'Target-NQN',
      targetNqnHint: 'Subsystemets NQN på targeten, börjar med nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace-ID inuti subsystemet — 1 om du är osäker.',
      dhchapCredential: 'Autentiseringsuppgift (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'En keystore-post av typen DH-HMAC-CHAP (NVMe) som används vid anslutningen — hemligheten färdas aldrig med storagen.',
      dhchapNone: 'Ingen autentisering',
      dhchapEmpty: 'Ingen autentiseringsuppgift av typen DH-HMAC-CHAP (NVMe) i keystoren — skapa den i System → Autentiseringsuppgifter. Utan den förblir anslutningen oautentiserad.',
      monitors: 'Monitorer',
      monitorsHint: 'Ceph-monitorernas endpoints, host[:port], separerade med komma eller radbrytning — standardport 6789.',
      pool: 'Pool',
      poolHint: 'RBD-poolen som ska konsumeras — en RBD-avbild per disk.',
      fs: 'Filsystem',
      fsHint: 'CephFS-filsystemets namn (mds_namespace vid mount).',
      fsPath: 'Path inuti filsystemet',
      fsPathHint: 'Absolut path inuti filsystemet som storagen monterar — / om du är osäker.',
      cephxCredential: 'Autentiseringsuppgift (cephx)',
      cephxCredentialHint: 'En keystore-post av typen cephx: användarnamn = klientnamn (client.…), secret = base64-nyckeln. Obligatorisk.',
      cephxNone: 'Ingen cephx-autentiseringsuppgift i keystoren — skapa en (typ: cephx) i System → Autentiseringsuppgifter, eller låt ett hanterat Ceph-kluster mynta den med "Föreslå som storage".',
      sharedByNature: 'Nätverksstorage är delad av naturen: varje medlem monterar den på samma TVirt-hanterade sökväg.',
      error: 'Storagen avvisades',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Annat',
        legacy: 'Legacy'
      },
      legacyHint: 'Fullt ut stödda — vi skulle bara inte välja dem för en ny installation.',
      proto: {
        dir: {
          name: 'Lokal mapp',
          desc: 'En directory på noden: enkelt och snabbt. Den är LOKAL för en nod, såvida inte pathen är en verkligt delad share — att märka den som delad när den inte är det kostar data.',
          usage: 'TVirt förvarar VM-diskar, ISO-/diskavbilder och templates här.'
        },
        nfs: {
          name: 'NFS',
          desc: 'En NFS-export monterad av klustret — delad av naturen.',
          usage: 'Huserar VM-diskar, ISO-/diskavbilder och templates.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'En Windows/Samba-share monterad av klustret — delad av naturen.',
          usage: 'Huserar VM-diskar, ISO-/diskavbilder och templates.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Ett fjärrfilsystem via SSH — utan behov av NAS-export.',
          usage: 'På roadmapen.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Block-LUN över IP med delad LVM ovanpå.',
          usage: 'Endast diskar — en thin-volym per disk; huserar varken ISO-avbilder eller templates.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block devices distribuerade över ett Ceph-kluster.',
          usage: 'Endast diskar — en RBD-avbild per disk, öppnad nativt av QEMU; huserar inga ISO-avbilder.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Cephs distribuerade filsystem, monterat av kärnan på klustret — shared by nature.',
          usage: 'Huserar VM-diskar, ISO-/diskavbilder och templates — dir-familjen på ett Ceph-filsystem (cephx-autentiseringsuppgift obligatorisk).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUN över FibreChannel-fabric — den klassiska FC-SAN:en.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Samma SCSI över FibreChannel, med FC-framarna inkapslade i Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (hela LUN:er)',
          desc: 'iSCSI-targeten som bärare av hela LUN:er: varje disk ÄR en LUN, skickad rå till gästen — ingen LVM emellan.',
          usage: 'Bara diskar — en hel LUN per disk, övertagen som den är; SAN-hemmet för diskar med delad skrivning.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (hela namespaces)',
          desc: 'NVMe-subsystemet som bärare av hela namespaces: varje disk ÄR en namespace, skickad rå till gästen.',
          usage: 'Bara diskar — en hel namespace per disk, övertagen som den är; delad skrivning ja, SCSI persistent reservations nej.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Fjärr-NVMe — ingen SCSI i vägen — över vanlig TCP, med delad LVM ovanpå.',
          usage: 'Endast diskar — en thin-volym per disk; huserar varken ISO-avbilder eller templates.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Fjärr-NVMe över FibreChannel-fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe på FibreChannel-fabricen som FCoE transporterar inuti Ethernet — lagren FCoE och NVMe/FC staplade.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI med datavägen flyttad till RDMA — vilken fabric som helst (InfiniBand, iWARP, RoCE). Passerad av NVMe/RDMA, finns fortfarande i arrayer och i ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Nativ SCSI över RDMA, eran före iSER: InfiniBand (med fabric-discovery) och RoCE — överlever i äldre HPC-storage.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Fjärr-NVMe över vilken RDMA-fabric som helst — InfiniBand, iWARP, RoCE v1 och v2: en enda konfiguration, det är noden som säger vilken den har.' },
        s3: { name: 'S3', desc: 'S3-kompatibel object storage — avbilder och backuper.' }
      }
    },
    catalogs: {
      title: 'Kataloger',
      createTitle: 'Skapa katalog',
      editTitle: 'Redigera katalog',
      docTitle: 'Katalog',
      notFound: 'Den här katalogen finns inte (längre?)',
      scopeHint: 'Den som läser detta scope ser (och kan använda) varje fil i katalogen',
      files: 'Filer',
      noFiles: 'Inga filer',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT-tpl',
        vmTemplate: 'VM-tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'system',
      systemTooltip: 'Systemkatalog: huserar plattformens inbyggda objekt och kan inte ändras'
    },
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Typ',
      physicalSize: 'Fysisk storlek',
      virtualSize: 'Virtuell storlek',
      importTemplateAction: 'Importera som VM Template',
      importTemplateLegacy: 'Inget deklarerat format — användbar som seed för diskar, inte importerbar',
      importTemplateTitle: 'Importera som VM Template',
      importTemplateSubmit: 'Importera',
      importTemplateError: 'Importen misslyckades',
      importTemplateHint: '.tvtpl-paketet blir en VM Template: manifestets frusna hårdvara plus en disk per post i arkivet, var och en verifierad mot sin checksumma. NIC och CD/DVD-medier ingår inte i ett arkiv — lägg till dem efter importen.',
      importTemplateQcow2Hint: 'En naken qcow2 blir en template med EN disk och den deklarerade standardhårdvaran: profil linux, UEFI, 2 vCPU, 2048 MiB, boot från sin enda disk. Rätta till vid deployen.',
      importTemplateName: 'Templatens namn',
      importTemplateNameHint: 'Tomt = {name} (-import-<n> om upptaget)',
      importTemplateStorage: 'Storage för diskarna',
      importTemplateMetadataStorage: 'Metadata-storage',
      importTemplateMetadataHint: 'En block-storage huserar inte VM-metadata (firmware, varstore) — välj en dir/nfs/cifs.',
      importTemplateStarted: 'Importen startad — templaten dyker upp i fliken Templates när tasken avslutas.',
      kind: {
        iso: 'ISO-avbild',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-template',
        'oci-image': 'OCI-avbild',
        'firmware-ovmf': 'OVMF-firmware'
      },
      title: {
        iso: 'ISO-avbilder',
        'ct-rootfs': 'CT-templates',
        'vm-template': 'VM-templates',
        'oci-image': 'OCI-avbilder',
        'firmware-ovmf': 'OVMF-firmware'
      },
      createTitle: {
        iso: 'Lägg till ISO-avbild',
        'ct-rootfs': 'Registrera CT-template',
        'vm-template': 'Lägg till VM-template',
        'oci-image': 'Lägg till OCI-avbild',
        'firmware-ovmf': 'Lägg till OVMF-firmware'
      },
      formatHint: 'Härlett ur den valda filens ändelse — rätta det om gissningen slog fel',
      tarballHint: 'En rootfs-tarball i LXC-standardformatet (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, eller en enkel .tar)',
      ociArchiveHint: 'En docker-archive-/oci-archive-tarball (.tar eller .tar.gz), till exempel från docker save',
      uploadResumeHint: 'Avbruten upload — filen väntar på upload: skicka igen med samma fil för att återuppta',
      moveTitle: 'Flytta fil',
      moveHint: 'Två oberoende dimensioner: Katalog flyttar länken (samma id, ingen byte flyttas, scopet blir målkatalogens); Storage flyttar datan — varje länkad kopia följer med, avvisas medan filen används. Valda tillsammans: först katalogen, sedan storagen.',
      moveCatalog: 'Målkatalog',
      moveCatalogHint: 'Bara länken byter hem: en VM som har filen monterad måste kunna se målkatalogen',
      keepCurrent: 'Ändra inte',
      rehomed: 'Länk flyttad till vald katalog',
      copyAction: 'Kopiera till katalog…',
      copyTitle: 'Kopiera till katalog',
      copyLinkHint: 'Kopian är en ny länk till samma data — ingenting dupliceras på storagen.',
      copyCatalog: 'Målkatalog',
      copyCatalogHint: 'Kopian är sättet en fil färdas mellan kataloger på',
      sameCatalog: 'Samma som källan',
      sharedObjectHint: 'Den här filens data delas av {count} länkade kopior',
      deleteLastLink: 'Det här är den SISTA länken till det här innehållet: även datan på storagen kommer att raderas.',
      deleteLinkOnly: 'Endast den här länken tas bort — datan finns kvar, fortfarande nåbar från de andra länkade kopiorna ({count}).',
      noCatalog: 'Det finns ingen katalog — skapa en',
      inlineCatalogName: 'Katalogens namn',
      embeddedChip: 'inbyggd',
      embeddedStorage: 'Inbyggd i plattformen',
      embeddedNoMove: 'Inbyggd plattformsfil: den bor inte på någon storage — klona den i stället',
      embeddedCopyHint: 'Klonen materialiserar de inbyggda bytena på en riktig storage: välj mål-storage och målkatalog — kopian är en vanlig fil',
      sourceEmbedded: 'Inbyggd i plattformen',
      nodesRow: 'Förekomst per nod',
      nodesSummary: '{present} av {total} noder har den',
      nodePresent: 'finns',
      nodeMissing: 'saknas',
      nodeUnknown: 'inte rapporterad ännu',
      nodesHint: 'Tillgången ligger på varje nods disk (paketet trantor-tvirt-assets): en nod som saknar den kan varken definiera en VM med denna firmware eller tillhandahålla Guest Tools. Olika versioner mellan noder är normalt under en rullande uppdatering.',
      downloadAction: 'Ladda ner',
      downloadNotReady: 'Innehållet är inte färdigt ännu — nedladdningen kräver en ready-fil',
      downloadDenied: 'Din roll inkluderar inte catalog.download — att ladda ner bytena är en separat rättighet från att använda filen',
      objectRow: 'Storage-objekt',
      objectLinksRow: 'Länkade kopior',
      declaredChecksum: 'Deklarerad SHA-256',
      usedByRow: 'Används av',
      usedByVms: 'VM',
      usedByDisks: 'Diskar',
      transferRow: 'Överföring',
      storageLockHint: 'Ändras bara med åtgärden Flytta'
    },
    objects: {
      action: 'Utforska innehållet',
      title: 'Storagens innehåll',
      hint: 'Read-only-inventering av vad som bor på den här storagen — varje objekt hanteras från sin egen sektion.',
      empty: 'Inget objekt registrerat på den här storagen',
      loadError: 'Kunde inte läsa in innehållet',
      colDetail: 'Detalj',
      manage: 'Hantera i dess sektion',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalogfil',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-metadata',
        appRoot: 'App-root',
        appVolume: 'App-volym'
      }
    },
    inventory: {
      tabCatalogs: 'Kataloger',
      storage: 'Storage',
      sizeGib: 'Storlek (GiB)',
      format: 'Format',
      size: 'Storlek',
      sourceType: 'Källa',
      sourceFile: 'Filuppladdning',
      sourceUrl: 'Nedladdning från URL',
      file: 'Fil',
      url: 'URL',
      checksum: 'SHA-256-checksumma',
      checksumHint: 'Obligatorisk: nedladdningen verifieras mot den här SHA-256:an',
      verifyChecksum: 'Verifiera checksumman',
      checksumOffHint: 'Nedladdningen accepteras utan verifiering — den beräknade SHA-256:an registreras ändå',
      uploading: 'Laddar upp…',
      move: {
        action: 'Flytta',
        diskTitle: 'Flytta disk',
        target: 'Mål-storage',
        diskHint: 'Disken behåller sin identitet: bytena färdas till den valda storagen. En VM som använder den måste vara avstängd; med snapshots närvarande avvisar en iSCSI-sida flytten.',
        noTargets: 'Ingen kompatibel mål-storage',
        submit: 'Flytta',
        error: 'Flytten avvisades'
      },
      clone: {
        action: 'Klona',
        title: 'Klona disk',
        name: 'Kopians namn',
        storage: 'Mål-storage',
        sameStorage: 'Samma som källan',
        linked: 'Linked clone',
        linkedHint: 'Omedelbart qcow2-overlay kedjat till källdisken (endast qcow2-källor). Standard är en fullständig kopia.',
        linkedCrossHint: 'En linked clone stannar på källans storage: välj "Samma som källan" för att aktivera den.',
        submit: 'Klona',
        error: 'Kloningen avvisades'
      },
      copy: {
        action: 'Kopiera',
        name: 'Kopians namn',
        storage: 'Mål-storage',
        sameStorage: 'Samma som källan',
        submit: 'Kopiera',
        error: 'Kopieringen avvisades'
      },
      taskStarted: 'Startad — fortsätter som task i bakgrunden',
      cephObjects: 'Gå till objektdetaljerna på Ceph',
      phase: {
        ready: 'Redo',
        creating: 'Skapas',
        'awaiting-upload': 'Väntar på upload',
        downloading: 'Laddas ner',
        verifying: 'Verifieras',
        deleting: 'Raderas',
        error: 'Fel',
        'in-use': 'I bruk'
      }
    }
  }
}
